import React, { useState } from "react";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Select } from "../../../components/form";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useQrCodes } from "../hooks";
import { formatDisplayDate } from "../../../helpers/date";
import { qrCodeStatusLabel } from "../../../helpers/enum-labels";

export const QrCodesList: React.FC = () => {
  const [status, setStatus] = useState("");
  const where: any = {};
  if (status) where.status = status;

  const { data, loading } = useQrCodes({ where });

  return (
    <div>
      <div className="mb-3">
        <Select
          label="Statut"
          className="w-48"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="">Tous</option>
          <option value="Available">Disponible</option>
          <option value="Assigned">Assigné</option>
        </Select>
      </div>

      {loading ? (
        <Loading />
      ) : !data?.qrCodes?.results?.length ? (
        <EmptyList text="Aucun QR code" />
      ) : (
        <Table>
          <TableHeader>
            <TableRow hover={false}>
              <TableCell header>Code</TableCell>
              <TableCell header align="center">
                Statut
              </TableCell>
              <TableCell header>Généré le</TableCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data?.qrCodes?.results?.map((qrCode) => (
              <TableRow key={`qr-code-${qrCode.id}`} hover={false}>
                <TableCell>{qrCode.code}</TableCell>
                <TableCell align="center">{qrCodeStatusLabel(qrCode.status)}</TableCell>
                <TableCell>{formatDisplayDate(qrCode.generatedAt)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};
